import { ButtonText } from "@ui"
import { mergeClasses } from "@lib/css"

import { SmartBannerButtonBorders } from "../atoms"

import type { ButtonProps } from "@ui"

export function SmartBannerButton(props: ButtonProps) {
  const { children, className, ...rest } = props
  const classes = `h-[39px] min-w-[88px] px-3 relative tracking-[0.5px] text-center`

  return (
    <ButtonText as="a" className={mergeClasses(classes, className)} {...rest}>
      <SmartBannerButtonBorders className="absolute top-0 left-0 w-full h-full" />
      <span className="relative inline-block mt-0.5 text-sm mobile-m:text-base">
        {children}
      </span>
    </ButtonText>
  )
}

export function SmartBannerButtonAndroid(props: ButtonProps) {
  const { children, className, ...rest } = props
  const classes = `h-[33px] tablet:h-[39px] min-w-[88px] px-2 tablet:px-3 relative tracking-[0.5px] text-center mr-[4px]`

  return (
    <ButtonText as="a" className={mergeClasses(classes, className)} {...rest}>
      <SmartBannerButtonBorders className="absolute top-0 left-0 w-full h-full" />
      <span className="relative inline-block mt-0.5 text-[10px] tablet:text-base leading-4 tablet:leading-5">
        {children}
      </span>
    </ButtonText>
  )
}
